import React from "react";
import NandiIcon from "../other-icons/NandiIcon";
import { getAuthStatus, cleanDataLayerPayload } from "../../helper/datalayer-utils";
import "./index.m.css";

const SubscribeBtn = () => {
  const handleSubscribe = () => {
    if (typeof window !== "undefined") {
      try {
        sessionStorage.setItem("subscribe_source", "header_button");
      } catch (e) {}

      const { status, uuid } = getAuthStatus();
      const formattedStatus = status === "not_logged_in" ? "non_logged_in" : status;
      const eventPayload = {
        event: "subscription_header_button_click",
        auth_status: formattedStatus,
        source: "DH_site"
      };

      if (status === "logged_in" && uuid && uuid !== "NA") {
        eventPayload.uuid = uuid;
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(cleanDataLayerPayload ? cleanDataLayerPayload(eventPayload) : eventPayload);

      const target = new URL("/subscribe", window.location.origin);
      target.searchParams.set(
        "redirect_url",
        `${window.location.pathname}${window.location.search}${window.location.hash}`
      );
      window.location.href = target.toString();
    }
  };

  return (
    <button type="button" styleName="subscribe-btn" onClick={handleSubscribe} aria-label="Subscribe">
      <NandiIcon width="21" height="15" />
      <span>Subscribe</span>
    </button>
  );
};

export default SubscribeBtn;
